import React from 'react';

import { Svg, SvgCircle, SvgPath, SvgProps } from '@rbilabs/universal-components';

import { primitive } from 'styles/constants/primitives';

const MARKER_DIMENSIONS = {
  width: 31,
  height: 44,
  viewBox: '0 0 31 44',
} as const;

const MARKER_PATH =
  'M15.295 0C6.839 0 0 6.84 0 15.295 0 26.766 15.295 43.7 15.295 43.7S30.59 26.766 30.59 15.295C30.59 6.839 23.75 0 15.295 0Zm0 20.758a5.464 5.464 0 0 1-5.463-5.463 5.464 5.464 0 0 1 5.463-5.463 5.464 5.464 0 0 1 5.463 5.463 5.464 5.464 0 0 1-5.463 5.463Z';

const MARKER_COLOR = primitive.bk.$bbqBrown;

interface DeliveryLocationMarkerProps extends SvgProps {
  accessibilityLabel?: string;
  testID?: string;
}

const defaultAccessibilityLabel = 'Delivery location marker';

export const DeliveryLocationMarker: React.FC<DeliveryLocationMarkerProps> = ({
  accessibilityLabel,
  testID,
  ...svgProps
}) => {
  return (
    <Svg
      width={MARKER_DIMENSIONS.width}
      height={MARKER_DIMENSIONS.height}
      viewBox={MARKER_DIMENSIONS.viewBox}
      fill="none"
      accessible={true}
      accessibilityLabel={accessibilityLabel || defaultAccessibilityLabel}
      testID={testID}
      {...svgProps}
    >
      <SvgCircle cx={17.5} cy={16.5} r={9.5} fill={primitive.bk.$white} />
      <SvgPath fillRule="evenodd" clipRule="evenodd" d={MARKER_PATH} fill={MARKER_COLOR} />
    </Svg>
  );
};

export const deliveryLocationMarkerSvg = `<svg width="${MARKER_DIMENSIONS.width}" height="${MARKER_DIMENSIONS.height}" viewBox="${MARKER_DIMENSIONS.viewBox}" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="17.5" cy="16.5" r="9.5" fill="${primitive.bk.$white}" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="${MARKER_PATH}"
      fill="${MARKER_COLOR}"
    />
</svg>`;
